
import WDDropdownMultiForm from './wd-dropdown-multi-form';

/**
	Note:
	This form can store objects as values, but it uses the labels to search.  This
	way it matches what a user would type.  what they see is the value expected
	*/
export default class WDDropdownObjectMultiForm extends WDDropdownMultiForm {

	get value()
	{
		return this.options.filter(opt => this.value.includes(opt.value)) || null;
	};

	set value(val)
	{
		const valArr = Array.isArray(val) && val.length > 0 ? val.map( x => x.value) : [];
		super.value = valArr;
	};

};

customElements.define('wd-dropdown-object-multi-form',WDDropdownObjectMultiForm);
